import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VerticalOffsetInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VerticalOffsetInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ offset, setOffset ] = useState<number>(project.encoder.overlayVerticalOffset);
  const debounce = 100;
  const min = 0;
  const max = 300;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = offset;

      if (offset < min) {
        value = min;
      } else if (offset > max) {
        value = max;
      }

      setOffset(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayVerticalOffset: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayVerticalOffset: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setOffset(project.encoder.overlayVerticalOffset);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayVerticalOffset]);

  return (
    <div className="vertical-offset-input">
      <div className="input-title">
        {t('producer.inputs.vertical-offset.title')}
        <Help
          title="Vertical Offset Padding"
          text="Once you have decided on the appearance and position of your caption box you can then move it up or down the screen for your exact position."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.vertical-offset.placeholder"
        value={offset.toString()}
        onChange={(value) => {setOffset(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.vertical-offset.footer')}</div>
    </div>
  );
};

export default React.memo(VerticalOffsetInput);
